export default __webpack_public_path__ + "static/media/OrderEatRepeat.764f1937.png";